var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("section", { staticClass: "box" }, [
      _vm.ok
        ? _c("i", {
            staticClass:
              "fas fa-check-circle fa-lg has-text-success is-pulled-right",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h1", { staticClass: "subtitle is-5" }, [
        _vm._v("\n    Administrar usuario\n  "),
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-2" }, [_vm._v("Certificado")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "notification is-warning" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("h1", { staticClass: "subtitle is-5" }, [
              _vm._v(
                _vm._s(_vm.withCertificate ? "Reemplazar" : "Subir nuevo") +
                  " certificado"
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-field",
              [
                _c(
                  "b-field",
                  {
                    staticClass: "file is-primary",
                    class: { "has-name": !!_vm.file },
                  },
                  [
                    _c(
                      "b-upload",
                      {
                        staticClass: "file-label",
                        attrs: { rounded: "", accept: "application/x-pkcs12" },
                        on: { invalid: _vm.invalid },
                        model: {
                          value: _vm.file,
                          callback: function ($$v) {
                            _vm.file = $$v
                          },
                          expression: "file",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "file-cta" },
                          [
                            _c("b-icon", {
                              staticClass: "file-icon",
                              attrs: { icon: "search" },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "file-label" }, [
                              _vm._v("Examinar"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.file
                          ? _c("span", { staticClass: "file-name" }, [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.file.name) +
                                  "\n                  "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "b-field",
              [
                _c("b-datepicker", {
                  attrs: {
                    locale: "es-AR",
                    placeholder: "Haga clic aquí",
                    icon: "calendar",
                    "trap-focus": "",
                  },
                  model: {
                    value: _vm.expireDateInput,
                    callback: function ($$v) {
                      _vm.expireDateInput = $$v
                    },
                    expression: "expireDateInput",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: { disabled: !_vm.file },
            on: { click: _vm.submit },
          },
          [_vm._v("Guardar")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.withCertificate
      ? _c("section", [
          !_vm.withActiveCertificate
            ? _c(
                "div",
                { staticClass: "notification is-warning mb-0 is-radiusless" },
                [
                  _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                  _vm._v(
                    "  El certificado se encuentra deshabilitado para uso\n    "
                  ),
                ]
              )
            : !_vm.isAboutToExpired && !_vm.isExpired
            ? _c(
                "div",
                { staticClass: "notification is-success mb-0 is-radiusless" },
                [
                  _c("i", { staticClass: "fas fa-check-circle" }),
                  _vm._v(
                    "  La copia de seguridad de certificado se encuentra disponible\n    "
                  ),
                ]
              )
            : _vm.isAboutToExpired && !_vm.isExpired
            ? _c(
                "div",
                { staticClass: "notification is-warning mb-0 is-radiusless" },
                [
                  _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                  _vm._v(
                    "  La copia de seguridad de certificado expira " +
                      _vm._s(_vm._f("moment")(_vm.expireDate, "from", "now")) +
                      "\n    "
                  ),
                ]
              )
            : !_vm.isAboutToExpired && _vm.isExpired
            ? _c(
                "div",
                { staticClass: "notification is-danger mb-0 is-radiusless" },
                [
                  _c("i", { staticClass: "fas fa-times-circle" }),
                  _vm._v(
                    "  La copia de seguridad de certificado se encuentra expirada. Venció el " +
                      _vm._s(_vm._f("moment")(_vm.expireDate, "L")) +
                      ", " +
                      _vm._s(_vm._f("moment")(_vm.expireDate, "from", "now")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "box mt-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-space-between is-align-items-center",
              },
              [
                !_vm.expireDate
                  ? _c("p", [
                      _vm._m(2),
                      _vm._v(
                        " No ha ingresado una fecha de vencimiento. Usted puede ingresar la fecha de vencimiento de su certificado y Signar le notificará a un mes de su expiración"
                      ),
                    ])
                  : _c("p", [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("span", { staticClass: "is-capitalized" }, [
                        _vm._v(
                          _vm._s(_vm._f("moment")(_vm.expireDate, "L")) +
                            " - " +
                            _vm._s(
                              _vm._f("moment")(_vm.expireDate, "from", "now")
                            )
                        ),
                      ]),
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "buttons is-right ml-3" }, [
                  _vm.withActiveCertificate
                    ? _c(
                        "a",
                        {
                          staticClass: "button is-small is-primary is-outlined",
                          on: { click: _vm.downloadCert },
                        },
                        [
                          _c("i", { staticClass: "fas fa-file-download" }),
                          _vm._v(" \n            Descargar\n          "),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "button is-small is-danger is-outlined",
                      on: { click: _vm.openDeleteCert },
                    },
                    [
                      _c("i", { staticClass: "fas fa-trash" }),
                      _vm._v(" Eliminar\n          "),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "Tiene la posibilidad de cargar un archivo .p12 para el usuario. En el caso que ya tenga una copia cargada, eliminará la copia actual almacenada."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Opcionalmente puede cargar la fecha de vencimiento del certificado. Signar le notificará visualmente al usuario cuando se encuentre a un mes de su expiración"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Como "),
        _c("b", [_vm._v("administrador")]),
        _vm._v(
          " de la organización, puede eliminar el certificado del usuario."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("Fecha de vencimiento "),
      _c("span", { staticClass: "is-size-7" }, [_vm._v("(opcional)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-text-primary" }, [
      _c("i", { staticClass: "fas fa-exclamation-triangle" }),
      _vm._v(" Atención:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "has-text-primary" }, [
      _c("i", { staticClass: "far fa-calendar" }),
      _vm._v(" Fecha de vencimiento"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }